import { useEffect, useState } from "react";
import PageHero from "../../Component/PageHero/PageHero";
import styles from "../../styles/pages/order-delivery.module.scss";
import { Image } from "antd";
// import OwnImage from "../components/Image/Image";
import OrderFromTo from "../../Component/OrderFromTo/OrderFromTo";
import { BiMinus } from "react-icons/bi";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
} from "antd";
import en from "../../localization/en";
import ar from "../../localization/ar";
import cls from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { setCustomerAddresses, setMetaData } from "../../redux/user/user.action";/****To Do */
import Api from "../../Network/ApiConfig";
import { useHistory, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { setUserOrder, setOrderPersonType, setPersonOptions, setPersonSearch,setSelectedPerson } from "../../redux/cart/cart.action";
import { Helmet } from "react-helmet";
import { css } from "@emotion/css";
import { PlusOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

let addInputItem;

function OrderDelivery() {
  const t = en;
  // console.log(process.env.REACT_APP_BASE_URL, "REACT_APP_BASE_URL")
  // const baseUrl = process.env.REACT_APP_BASE_URL;
  // const baseUrl = "http://native-001-site30.ctempurl.com";
  // const params = useParams();
  const location = useLocation();

  let addInputItem;
const { userAddress, currentLang, currentUser } = useSelector(
    (state) => state.user
  );
const { order } = useSelector(
  (state) => state.cart
);

  const [form] = Form.useForm();
  const history = useHistory();
  const [deliveryType, setdeliveryType] = useState(0);
  const [deliveryTypesList, setDeliveryTypesList] = useState([]);
  const metaDataInfo = useSelector((state) => state.user.metaData || {});
  const { PackgeSizes, Categories, Settings, Services } = metaDataInfo;
  const {
    orderPersonType,
    personSearch,
    personOptions,
    selectedPerson,
  } = useSelector((state) => state.cart); 
  const [personLoading, setPersonLoading] = useState(false);

  // console.log(metaDataInfo, metaDataInfo);
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(setUserOrder(null));
    if (!currentUser) {
      history.push("/" + currentLang + "/login");
      // return false;
    }
    Api.get("MetaData/GetMetaData").then(
      (res) => {
        dispatch(setMetaData(res?.data?.model));
      },
      (err) => {
        // console.log(err, "errrrrrrrrrrrrrrrrrrrrrrrrrrr")
      }
    );
    // Api.get("Customers/GetCustomerAddresses").then(
    //   (res) => {
    //     dispatch(setCustomerAddresses(res?.data?.model));
    //   },
    //   (err) => {
    //     console.log(err);
    //   }
    // );
    console.log(location?.state?.key, "location?.state?.key");
    if (!location.state?.serviceId) {
      history.replace({
        ...location,
        state: { ...location.state, serviceId: 1 }
      });
    }
    const deliveryTypesList = Services?.find(
      (s) => s?.Id === location?.state?.serviceId
    )?.ServiceDeliveryTypes;
    setDeliveryTypesList(deliveryTypesList);
    console.log(deliveryTypesList, "deliveryTypesList");
    
    if (order) {
      setTimeout(() => {
        // eslint-disable-next-line no-unsafe-optional-chaining
        let resetOrderItems = [...(order?.orderItems || [])];
        console.log(resetOrderItems);
        resetOrderItems.shift();
        form.setFieldsValue({
          FromCustomerAddressId: order?.FromCustomerAddressId,
          ToCustomerAddressId: order?.ToCustomerAddressId,
          PackgeSizeId: order?.PackgeSizeId,
          ServiceDeliveryTypeId: order?.ServiceDeliveryTypeId,
          CategoryId: order?.CategoryId,
          DeliveryDateTime: dayjs(order?.DeliveryDateTime),
          DeliveryNote: order?.DeliveryNote,
          Name: order?.orderItems?.[0]?.Name,
          Price: order?.orderItems?.[0]?.Price,
          Count: order?.orderItems?.[0]?.Count,
          orderItems: resetOrderItems,
        });
      }, 300);
    }
  }, [location?.state?.key]);

  useEffect(() => {
    const body = document.querySelector("#root");
    body?.scrollIntoView({
      behavior: "smooth",
    });
    dispatch(setUserOrder({}));
  }, []);

  useEffect(() => {
    const deliveryTypesList = Services?.find(
      (s) => s?.Id === location?.state?.serviceId
    )?.ServiceDeliveryTypes;
    setDeliveryTypesList(deliveryTypesList);
  }, [userAddress, location?.state?.key, Services, location?.state?.serviceId]);

  const handelChangeDelivery = (type) => {
    setdeliveryType(type);
    form.setFieldsValue({
      DeliveryDateTime: null,
    });
  };

  useEffect(() => {
    if (selectedPerson?.Id && form) {
      form.setFieldsValue({ OrderPersonId: selectedPerson.Id });
    }
  }, [selectedPerson?.Id]);
  

  const onFinish = (values) => {
    console.log(values, "values");
    
    let orderItems = [];
    if (location?.state?.serviceId === 2) {
      if (values?.orderItems) {
        orderItems = [
          { Name: values?.Name, Price: values?.Price, Count: values?.Count },
          ...values?.orderItems,
        ];
      } else {
        orderItems = [
          { Name: values?.Name, Price: values?.Price, Count: values?.Count },
        ];
      }
    }

    const subTotal = orderItems?.reduce(
      (acc, pro) => acc + +pro.Price * +pro.Count,
      0
    );
    const vatCost = subTotal * (+Settings[1]?.SettingValue || 5);
    // console.log(vatCost?.toFixed(2))
    // return false;
    let body = {
      FromCustomerAddressId: values?.FromCustomerAddressId,
      ToCustomerAddressId: values?.ToCustomerAddressId,
      PackgeSizeId: values?.PackgeSizeId,
      ServiceDeliveryTypeId: values?.ServiceDeliveryTypeId,
      CategoryId: values?.CategoryId,
      DeliveryDateTime: dayjs(values?.DeliveryDateTime).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      ),
      DeliveryNote: values?.DeliveryNote,
      orderItems: orderItems,
      VAT: vatCost?.toFixed(2) || vatCost,
      ResetImage: null,
      Total: subTotal,
      SubTotal: subTotal,
      OrderTypeId: 2,
      ServiceId: location?.state?.serviceId,
      OrderPersonType: orderPersonType,
      OrderPersonId: selectedPerson?.Id || values?.OrderPersonId,
      // "CompanyPackgeSizeId":2,
      PayerTypeId:1,
      // "PaymentTypeId": 1,
      ReceiverId: 0,
      // "DeliveryCost": 100,
      // "OrderStatusId": 1,
    };

    console.log(body);
    
    dispatch(setUserOrder(body));
    history.push({
      pathname: "/add-order-company",
      state: {
        serviceId: location?.state?.serviceId,
      },
    });
  };

  function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  // function disabledDate(current) {
  //   // Can not select days before today and today
  //   // console.log(current)
  //   // console.log(+deliveryType?.FromHour, "+deliveryType?.FromHour")
  //   return current && current < dayjs().add(+deliveryType?.FromHour , 'hours');
  // }

  function disabledDate(current) {
    // console.log(current, '9999999999999999999');
    let start = dayjs().add(+deliveryType?.FromHour, "hour");
    let end = dayjs().add(+deliveryType?.ToHour, "hour");

    if (current < dayjs(start).subtract(1, "day")) {
      return true;
    } else if (current > dayjs(end)) {
      return true;
    } else {
      return false;
    }
  }

  const disabledDateTime = (current) => {
    console.log("current:", current);
    // const current = dayjs();
    console.log(dayjs(current || new Date()), "dayjs(current)");
    const start = dayjs().add(+deliveryType?.FromHour, "hour");
    console.log("Start:", start);
    const end = dayjs().add(+deliveryType?.ToHour, "hour");
    console.log("End:", end);
    const isStartSameDay = dayjs(current || new Date()).isBefore(start);
    console.log("Is start same day:", isStartSameDay);
    const isEndSameDay = dayjs(current || new Date()).isAfter(end);
    console.log("Is end same day:", isEndSameDay);

    const isEndSameDayWithDayes =
      dayjs(current).format("L") === dayjs(end).format("L");

    let disabledHoursList = [];
    // return {
    //   disabledHours: () => disabledHoursList,
    // };
    if (isStartSameDay) {
      console.log(start, "start.................. isStartSameDay");
      console.log(dayjs(start).format("H"), "start.hour() isStartSameDay");
      disabledHoursList = [
        ...disabledHoursList,
        ...range(0, dayjs(start).format("H")),
      ];
      console.log(disabledHoursList, "disabledHoursList isStartSameDay");
    }
    // if (isEndSameDay || dayjs(current).format('L') === dayjs(end).format('L')) {
    if (isEndSameDay || isEndSameDayWithDayes) {
      console.log(end, "end.................. isEndSameDay");
      // console.log(dayjs(end).format('h'), 'end.hour() isEndSameDay');
      // console.log(dayjs(end).format('h'), 'end.hour() isEndSameDay');
      disabledHoursList = [
        ...disabledHoursList,
        ...range(dayjs(end).format("H"), 24),
      ];
    }
    if (!isStartSameDay && !isEndSameDay) {
      disabledHoursList = [];
    }
    // console.log(isStartSameDay, 'isStartSameDay');
    // console.log(isEndSameDay, 'isEndSameDay');
    return {
      disabledHours: () => disabledHoursList,
    };
  };

  // const disabledDateTime = (current) => {
  //   // const selectedDate = dayjs(form.getFieldValue("DeliveryDateTime") || null)
  //   console.log(current, 'current');
  //   console.log(deliveryType, 'deliveryType');

  //   let start = dayjs().add(+deliveryType?.FromHour, 'hours');
  //   let end = dayjs().add(+deliveryType?.ToHour, 'hours');
  //   console.log(end, 'end');
  //   // console.log(dayjs(current).format("L"), "currrrrrrrrrrrrrrrrrrrrrent")
  //   // console.log(dayjs(start).format("L"), "start")
  //   // console.log(dayjs(end).format("L"), "end")
  //   // let isStartSameDay = dayjs(current).format("L") === dayjs(start).format("L");
  //   // let isEndSameDay = dayjs(current).format("L") === dayjs(end).format("L");
  //   let isStartSameDay = dayjs(current).isSameOrBefore(dayjs(start));
  //   let isEndSameDayWithDayes =
  //     dayjs(current).format('L') === dayjs(end).format('L');
  //   let isEndSameDay = dayjs(current).isSameOrAfter(dayjs(end));

  //   console.log('isEndSameDay', isEndSameDay);
  //   // console.log("current", current)
  //   let disabledHoursList = [];
  //   if (isStartSameDay) {
  //     disabledHoursList = [...disabledHoursList, ...range(0, start.hours())];
  //   }
  //   if (isEndSameDay || isEndSameDayWithDayes) {
  //     disabledHoursList = [...disabledHoursList, ...range(end.hours(), 24)];
  //   }
  //   // console.log(disabledHoursList, "disabledHoursList")
  //   return {
  //     disabledHours: () => disabledHoursList,
  //     // disabledHours: () => range(0, start.hours())
  //     // disabledHours: () => range(end.hours(), 24)
  //     // disabledHours: () => range(0, 24).splice(4, 20)
  //     // disabledMinutes: () => range(30, 60),
  //   };
  // };

  const disabledRangeTime = (_, type) => {
    if (type === "start") {
      return {
        disabledHours: () => range(0, 60).splice(4, 20),
        disabledMinutes: () => range(30, 60),
      };
    }
    return {
      disabledHours: () => range(0, 60).splice(20, 4),
      disabledMinutes: () => range(0, 31),
    };
  };

  const handleTypeChange = (value) => {
    dispatch(setOrderPersonType(value));
    form.setFieldsValue({ OrderPersonType: value, OrderPersonId: undefined });
    dispatch(setPersonSearch(""));
    dispatch(setPersonOptions([]));
    dispatch(setSelectedPerson(null));
  };
  
  const handlePersonSearch = async (searchValue) => {
    dispatch(setPersonSearch(searchValue));
    setPersonLoading(true);
  
    try {
      let res;
      if (orderPersonType === "customer") {
        res = await Api.get(`Business/SearchCustomerByEmailOrPhone?Query=${searchValue}`);
      } else if (orderPersonType === "business") {
        res = await Api.get(`Business/SearchBusinessesByEmailOrPhone?Query=${searchValue}`);
      }
      // The .model or .data.model might depend on your API shape
      dispatch(setPersonOptions(res?.data?.model || []));
    } catch (e) {
      dispatch(setPersonOptions([]));
    }
    setPersonLoading(false);
  };
  
  // const handlePersonSelect = (id) => {
  //   const found = personOptions.find((p) => p.Id === id);
  //   setSelectedPerson(found);
  
  //   // If you want to set their address (assuming they have an Address/Addresses field)
  //   // e.g., set as FromCustomerAddressId:
  //   if (found?.AddressId) {
  //     form.setFieldsValue({ FromCustomerAddressId: found.AddressId });
  //   }
  // };
  
  const handlePersonSelect = async (id) => {
    const found = personOptions.find((p) => p.Id === id);
    dispatch(setSelectedPerson(found));
  
    // Fetch addresses for selected person
    if (orderPersonType === "customer" && found?.Id) {
      Api.get(`Business/GetCustomerAddressesById?Id=${found.Id}&Page=0`).then(
        (res) => {
          dispatch(setCustomerAddresses(res?.data?.model));
          // Optionally, set the first address as default
          if (res?.data?.model?.length) {
            form.setFieldsValue({ FromCustomerAddressId: res.data.model[0].Id });
          }
        },
        (err) => {
          dispatch(setCustomerAddresses([]));
        }
      );
    } else if (orderPersonType === "business" && found?.Id) {
      Api.get(`Business/GetBusinessAddresses?Id=${found.Id}&Page=0`).then(
        (res) => {
          dispatch(setCustomerAddresses(res?.data?.model));
          // Optionally, set the first address as default
          if (res?.data?.model?.length) {
            form.setFieldsValue({ FromCustomerAddressId: res.data.model[0].Id });
          }
        },
        (err) => {
          dispatch(setCustomerAddresses([]));
        }
      );
    }
  };
  
  useEffect(() => {
  if (
    orderPersonType &&
    selectedPerson?.Id &&
    personOptions.length > 0
  ) {
    handlePersonSelect(selectedPerson.Id);
  }
}, [orderPersonType, selectedPerson?.Id, personOptions]);


  const container = css`
    margin-left: auto !important;
    margin-right: auto !important;
    width: 80%;

    @include mq("xxl", min) {
      max-width: 1427px;
    }
    @include mq("xxl") {
      max-width: 1127px;
    }
    @include mq("xl") {
      max-width: 933px;
    }
    @include mq("lg") {
      max-width: 723px;
    }
    @include mq("md") {
      max-width: 100vw;
      padding: 0 1.5rem;
    }
    `;

    const formItemWrapper = css`
      background: #ffffff 0% 0% no-repeat padding-box;
      box-shadow: 0px 0px 50px #0000000d;
      border-radius: 26px;
      padding: 8rem 11rem;
      @media only screen and (max-width: 992px) {
        padding: 6rem 3rem;
      }
      .form-title {
        font-size: 4rem;
        color: #294151;
        margin-bottom: 3.5rem;
        font-weight: 600;
        letter-spacing: 0.32px;
        display: flex;
        align-items: center;
        span {
          color: #612166;
          margin: 0 8px;
        }
        @media only screen and (max-width: 992px) {
          font-size: 3rem;
        }
      }
      .form-txt-p {
        font-size: 2.4rem;
        line-height: 1.58;
        color: #7f8897;
        margin-bottom: 4rem;
        a,
        span {
          font-weight: 500;
          color: #612166;
          margin: 0 6px;
          cursor: pointer;
        }
      }
      .remember-row-holder {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 40px;
        .ant-checkbox + span {
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0.16px;
          > a {
            color: #612166;
            font-weight: 600;
            margin: 0 4px;
            cursor: pointer;
          }
        }
        .ant-form-item {
          margin-bottom: 0;
        }
        > a {
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0.16px;
          color: #294151;
        }
      }
      .have-account-holder {
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 0.16px;
        color: #294151;
        font-size: 20px;
        margin-top: 30px;
        a,
        span {
          color: #612166;
          font-weight: 600;
          margin: 0 4px;
          cursor: pointer;
        }
      }
    
  `;

  const formInputWrapper = css`
    .ant-input-number{
      .ant-input-number-input-wrap{
        height: 100%;
      }
      input{
        height: 100%;
      }
    }
    .ant-input, .ant-select .ant-select-selector, .ant-input-number, .pac-target-input {
      margin-bottom: 0.5rem;
      height: 7.5rem;
      border: 0.5px solid #e6e7ea;
      border-radius: 12px;
      letter-spacing: 0.14px;
      color: $color-black-2;
      font-size: 2.1rem;
      padding: 4px 11px;
      width: 100%;
      max-width:100% !important;
    }
    .ant-select .ant-select-selector{
      input{
        height: 100% !important;
      }
        max-width: 100% !important;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder,
    .ant-select-single .ant-select-selector .ant-select-selection-item{
      display: flex;
      align-items: center;
       max-width: 100% !important;
    }
    textarea {
      letter-spacing: 0.14px;
      // color: #000;
      color: #949ba7;
      font-size: 1.6rem;
      height: auto !important;
      border: 0.5px solid #e6e7ea;
      border-radius: 12px;
      padding: 2rem;
    }
  `;

  const color_primary = "#612166"; // Replace with your primary color
  const color_secondary = "#294151"; // Replace with your secondary color
  const heading_primary  = css`
            font-size: 3rem;
            font-weight: 600;
            line-height: 1.63;
            letter-spacing: 0.48px;
            color: ${color_secondary};
            text-align: center;
            text-transform: capitalize;
            margin-bottom: 3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;

            &:lang(ar) {
              flex-direction: row-reverse;
            }
            &.left {
              text-align: left;
              justify-content: flex-start;
              &:lang(ar) {
                justify-content: flex-end;
              }
            }
            .color {
              color: ${color_primary};
              // padding-left: 5px;
            }

            &.small {
              font-size: 3rem;
            }`;


    const typeDropdownWrapper = css`
      display: flex;
      align-items: center;
      gap: 12px;
      .add-type-btn {
        background: #f8f7fc;
        border: none;
        border-radius: 6px;
        padding: 6px 10px;
        cursor: pointer;
        color: #612166;
        font-size: 1.9rem;
        display: flex;
        align-items: center;
        transition: background 0.2s;
        &:hover {
          background: #f1ecf7;
          color: #38114d;
        }
      }
    `;

    const selectCardHolder = css`
      .ant-radio-button-wrapper {
        &.ant-radio-button-wrapper-checked {
          border-color: #612166 !important;
          box-shadow: 0 3px 99px 0 rgba(0, 0, 0, 0.04);
        }
      }
      img {
        object-fit: contain;
      }`;

    const btnPrimary = css`
      padding: 1rem 4rem;
      height: 9.5rem;
      border-radius: 48.8px;
      background-image: linear-gradient(100deg, #8c4191 -39%, #612166 51%);
      font-size: 2.5rem;
      font-weight: 500;
      text-align: center;
      color: $color-white-1;
      text-transform: capitalize;

      &.fw {
        display: block;
        width: 100%;
      }`;
  return (
    <>
    <Helmet>
        <title>{t.orderDelivery}</title>
        <link
          rel="canonical"
          href={`https://www.chauffeur-hub.com/${currentLang}/order-delivery`}
        />
        <meta name="description" content={t.bannerChauffeur} />
      </Helmet> 
      <PageHero
        title={
          +location?.state?.serviceId === 2
            ? t.personalShopper
            : t.orderDelivery
        }
      />
      <div className={styles.order_delivery_page}>
        <div className={container}>
          <div
            className={cls(
              "order-delivery-page-holder",
              styles.order_delivery_page_holder
            )}
          >
            <div className={cls("form-wrapper", styles.form_wrapper, formItemWrapper)}>
              <Form form={form} name="basic" onFinish={onFinish}>

              <Form.Item
                label="Type"
                labelCol={{ span: 24 }}
                name="OrderPersonType"
                rules={[{ required: false, message: "Please select type" }]}
                className={cls(formInputWrapper, "input-wrapper", styles.input_from_to)}
              >
                <div className={typeDropdownWrapper} style={{ width: "100%" }}>
                  <Select
                    className={styles.order_Delivery_input}
                    placeholder="Select Type"
                    onChange={handleTypeChange}
                    style={{ width: "100%" }}
                    value={orderPersonType}
                    allowClear
                  >
                    <Select.Option value="customer">Customer</Select.Option>
                    <Select.Option value="business">Business</Select.Option>
                  </Select>
                  {orderPersonType && (
                    <button
                      type="button"
                      className="add-type-btn"
                      aria-label="Add"
                      onClick={() => {
                        if (orderPersonType === "business") {
                          history.push("/add-new-business");
                        } else if (orderPersonType === "customer") {
                          history.push("/add-new-customer");
                        }
                      }}
                      tabIndex={0}
                      style={{
                        marginLeft: 8,
                        height: 40,
                        minWidth: 40,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <PlusOutlined style={{ fontSize: 22 }} />
                    </button>
                  )}

                </div>
              </Form.Item>



              {orderPersonType && (
                <Form.Item
                  name="OrderPersonId"
                  rules={[{ required: true, message: `Please select a ${orderPersonType}` }]}
                  className={cls(formInputWrapper, "input-wrapper", styles.input_from_to)}
                >
                  <Select
                    showSearch
                    placeholder={`Search ${orderPersonType} by Email or Phone`}
                    filterOption={false}
                    notFoundContent={personLoading ? "Loading..." : null}
                    onSearch={handlePersonSearch}
                    onChange={handlePersonSelect}
                    value={selectedPerson?.Id}
                    style={{ width: "100%" }}
                    optionLabelProp="label"
                  >
                    {personOptions.map((item) => (
                      <Select.Option
                        key={item.Id}
                        value={item.Id}
                        label={item.AspNetUsers.FullName || item.AspNetUsers.Email || item.AspNetUsers.PhoneNumber}
                      >
                        <div>
                          <strong>{item.AspNetUsers.FullName || item.AspNetUsers.Email || item.AspNetUsers.PhoneNumber}</strong>
                          {item.AspNetUsers.Email && <div style={{ color: "#888" }}>{item.AspNetUsers.Email}</div>}
                          {item.AspNetUsers.PhoneNumber && <div style={{ color: "#888" }}>{item.AspNetUsers.PhoneNumber}</div>}
                        </div>
                      </Select.Option>
                    ))}
                  </Select>
                  <Tooltip title="Use email or phone number with country code">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "25px",
                        height: "40px",
                        alignItems: "center",
                        fontSize: "20px",
                      }}                      
                    />
                  </Tooltip>
                </Form.Item>
    )}


                <div className={styles.form_item_wrapper}>
                  <OrderFromTo
                    title={
                      +location?.state?.serviceId === 2
                        ? t.personalShopper
                        : t.orderDelivery
                    }
                  >
                    <Form.Item
                      label={t.from}
                      labelCol={{ span: 24 }}
                      name="FromCustomerAddressId"
                      rules={[
                        {
                          required: true,
                          message: `${t.Pleaseinput} ${t.address}`,
                        },
                      ]}
                      className={cls(formInputWrapper,"input-wrapper", styles.input_from_to)}
                    >
                      <Select
                        className={styles.order_Delivery_input}
                        placeholder={`${t.enterCaptalized} ${t.addressCaptalized}`}
                        optionFilterProp="children"
                        disabled={!orderPersonType || !selectedPerson}
                        // showSearch
                        // filterOption={(input, option) =>
                        //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        // }
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider style={{ margin: "8px 0" }} />
                            <div
                              style={{ textAlign: "center", paddingBottom: 4 }}
                            >
                              <Button
                                type="link"
                                onClick={() => {
                                  history.push({
                                    pathname: "/address",
                                    state: {
                                      show_add_address: true,
                                      back_to_order: true,
                                      serviceId: location?.state?.serviceId,
                                      orderPersonId: form.getFieldValue("OrderPersonId"),
                                      orderPersonType: form.getFieldValue("OrderPersonType"),
                                    },
                                  });
                                }}
                              >
                                + {t.addNewAdress}
                              </Button>
                            </div>
                          </>
                        )}
                      >
                        {userAddress?.map((address) => (
                          <Select.Option key={address?.Id} value={address?.Id}>
                            <strong>{address?.Title}</strong> {"   "} (
                            {address?.Caption})
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={t.to}
                      labelCol={{ span: 24 }}
                      name="ToCustomerAddressId"
                      rules={[
                        {
                          required: true,
                          message: `${t.Pleaseinput} ${t.deliveryLocation}`,
                        },
                      ]}
                      className={cls(formInputWrapper,"input-wrapper", styles.input_from_to)}
                    >
                      <Select
                        className={styles.order_Delivery_input}
                        placeholder={`${t.enterCaptalized} ${t.deliveryLocation}`}
                        optionFilterProp="children"
                        disabled={!orderPersonType || !selectedPerson}
                        // showSearch
                        // filterOption={(input, option) =>
                        //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        // }
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider style={{ margin: "8px 0" }} />
                            <div
                              style={{ textAlign: "center", paddingBottom: 4 }}
                            >
                              <Button
                                type="link"
                                onClick={() => {
                                  history.push({
                                    pathname:  "/address",
                                    state: {
                                      show_add_address: true,
                                      back_to_order: true,
                                      serviceId: location?.state?.serviceId,
                                      orderPersonId: form.getFieldValue("OrderPersonId"),
                                      orderPersonType: form.getFieldValue("OrderPersonType"),
                                    },
                                  });
                                }}
                              >
                                + {t.addNewAdress}
                              </Button>
                            </div>
                          </>
                        )}
                      >
                        {userAddress?.map((address) => (
                          <Select.Option key={address?.Id} value={address?.Id}>
                            <strong>{address?.Title}</strong> {"   "} (
                            {address?.Caption})
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </OrderFromTo>
                </div>

                {/* PACKAGE SIZE */}
                <div className={styles.form_item_wrapper}>
                  <div className={selectCardHolder}>
                    <div className={cls("heading-primary left small", heading_primary)}>
                      <span>{t.package}</span>
                      <span className="color">{t.size}</span>
                    </div>
                    <Form.Item
                      name="PackgeSizeId"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Radio.Group
                        buttonStyle="outline"
                        size="PackgeSizes"
                        className={cls(styles.select_card_wrapper)}
                      >
                        <Row
                          gutter={[40, 40]}
                          justify="space-between"
                          className={cls(styles.select_card_grid)}
                        >
                          {PackgeSizes?.map((size) => (
                            <Col key={size?.Id} xs={22} sm={12} lg={8}>
                              <Radio.Button
                                value={size?.Id}
                                className={cls(styles.select_card_item)}
                              >
                                <div
                                  className={cls(styles.select_card_item_Card)}
                                >
                                  <div>
                                    <Image
                                      src={size?.Image}
                                      width={125}
                                      height={120}
                                      alt={"size"}
                                      preview={false}
                                    />
                                  </div>
                                  <h4>
                                    {currentLang === "en"
                                      ? size?.Name
                                      : size?.NameLT}
                                  </h4>
                                  <p>
                                    {currentLang === "en"
                                      ? size?.Description
                                      : size?.DescriptionLT}
                                  </p>
                                </div>
                              </Radio.Button>
                            </Col>
                          ))}
                        </Row>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>
                {/* DELIVARY TYPE */}
                <div className={styles.form_item_wrapper}>
                <div className={selectCardHolder}>
                    <div className={cls("heading-primary left small", heading_primary)}>
                      <span>{t.delivery}</span>
                      <span className="color">{t.type}</span>
                    </div>
                    <Form.Item
                      name="ServiceDeliveryTypeId"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Radio.Group
                        buttonStyle="outline"
                        size="DeliveryTypes"
                        className={cls(styles.select_card_wrapper)}
                      >
                        <Row
                          gutter={[40, 40]}
                          justify="space-between"
                          className={cls(styles.select_card_grid)}
                        >
                          {deliveryTypesList?.map((type) => (
                            <Col key={type?.Id} xs={22} sm={12} lg={8}>
                              {" "}
                              <Radio.Button
                                value={type?.Id}
                                className={cls(styles.select_card_item)}
                                onChange={() =>
                                  handelChangeDelivery(type?.DeliveryType)
                                }
                              >
                                <div
                                  className={cls(styles.select_card_item_Card)}
                                >
                                  <div>
                                    <Image
                                      src={type?.DeliveryType?.Image}
                                      width={140}
                                      height={120}
                                      alt={"size"}
                                      preview={false}
                                    />
                                  </div>
                                  <h4>
                                    {currentLang === "en"
                                      ? type?.DeliveryType?.Name
                                      : type?.DeliveryType?.NameLT}
                                  </h4>
                                  <p>
                                    {currentLang === "en"
                                      ? type?.DeliveryType?.Description
                                      : type?.DeliveryType?.DescriptionLT}
                                  </p>
                                </div>
                              </Radio.Button>
                            </Col>
                          ))}
                        </Row>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>
                {/* CATEGORY TYPE */}
                <div className={styles.form_item_wrapper}>
                  <div className={selectCardHolder}>
                    <div className={cls("heading-primary left small", heading_primary)}>
                      <span>{t.category}</span>
                      <span className="color">{t.type}</span>
                    </div>
                    <Form.Item
                      name="CategoryId"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Radio.Group
                        buttonStyle="outline"
                        size="Categories"
                        className={cls(styles.select_card_wrapper)}
                      >
                        <Row
                          gutter={[40, 40]}
                          justify="space-between"
                          className={cls(styles.select_card_grid)}
                        >
                          {Categories?.map((category) => (
                            <Col key={category?.Id} xs={22} sm={12} lg={8}>
                              {" "}
                              <Radio.Button
                                value={category?.Id}
                                className={cls(styles.select_card_item)}
                              >
                                <div
                                  className={cls(styles.select_card_item_Card)}
                                >
                                  <div>
                                    <Image
                                      src={category?.Image}
                                      width={94}
                                      height={94}
                                      alt={"size"}
                                      preview={false}
                                    />
                                  </div>
                                  <h4>
                                    {currentLang === "en"
                                      ? category?.Name
                                      : category?.NameLT}
                                  </h4>
                                </div>
                              </Radio.Button>
                            </Col>
                          ))}
                        </Row>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>
                {/* DELIVERY TIME */}
                <div className={styles.form_item_wrapper}>
                  <div className="delivery_time_holder">
                    <h2 className={cls("heading-primary left small", heading_primary)}>
                      <span>{t.delivery}</span>
                      <span className="color">Date</span>
                    </h2>

                    <Form.Item
                      name="DeliveryDateTime"
                      rules={[
                        {
                          required: true,
                          message: "Please select a delivery date"
                        },
                      ]}
                    >
                      <DatePicker
                        // showTime
                        size="large"
                        // use12Hours
                        // showNow={false}
                        format="MM-DD-YYYY"
                        placeholder={
                          currentLang === "en"
                            ? "mm / dd / yyyy"
                            : "شهر / يوم / سنة"
                        }
                        className={styles.date_picker}
                        disabledDate={disabledDate}
                        // disabledTime={disabledDateTime}
                      />
                    </Form.Item>
                  </div>
                </div>

                {+location?.state?.serviceId === 2 && (
                  <div className={styles.form_item_wrapper}>
                    <div className="delivery_time_holder">
                      <h2 className={cls("heading-primary left small", heading_primary)}>
                        <span>{t.product}</span>
                        <span className="color">{t.name}</span>
                      </h2>
                      {/*  */}

                      <div className={styles.products_form_list}>
                        <div className={styles.products_form_list_item}>
                          <Form.Item
                            name="Name"
                            rules={[{ required: true }]}
                            className={cls(
                              "input-wrapper",
                              styles.form_item_order_name
                            )}
                          >
                            <Input placeholder={`${t.itemName}`} />
                          </Form.Item>
                          <Form.Item
                            name="Price"
                            rules={[{ required: true }]}
                            className={cls(
                              "input-wrapper",
                              styles.form_item_order_price
                            )}
                          >
                            <InputNumber
                              placeholder={t.SAR}
                              min={1}
                              className={styles.input_num}
                            />
                          </Form.Item>
                          <Form.Item
                            name="Count"
                            rules={[{ required: true }]}
                            className={cls(
                              "input-wrapper",
                              styles.form_item_order_price
                            )}
                          >
                            <InputNumber
                              placeholder={t.count}
                              min={1}
                              className={styles.input_num}
                            />
                          </Form.Item>
                          <Button
                            className={styles.add_prod_btn}
                            type="primary"
                            ghost
                            onClick={() => addInputItem()}
                          >
                            {/* <OwnImage
                            src="/images/icons/Icon awesome-plus.svg"
                            layout="fill"
                            alt="plus icon"
                          /> */}
                            + {t.addProduct}
                          </Button>
                        </div>
                        <Form.List name="orderItems">
                          {(fields, { add, remove }) => {
                            addInputItem = add;
                            console.log(fields, "fieldsfieldsfields");
                            return fields.map((field) => (
                              <div
                                key={field.key}
                                className={styles.products_form_list_item}
                              >
                                <Form.Item
                                  name={[field.name, "Name"]}
                                  rules={[{ required: true }]}
                                  className={cls(
                                    "input-wrapper",
                                    styles.form_item_order_name
                                  )}
                                >
                                  <Input placeholder={`${t.itemName}`} />
                                </Form.Item>
                                <Form.Item
                                  name={[field.name, "Price"]}
                                  rules={[{ required: true }]}
                                  className={cls(
                                    "input-wrapper",
                                    styles.form_item_order_price
                                  )}
                                >
                                  <InputNumber
                                    placeholder={t.SAR}
                                    min={1}
                                    className={styles.input_num}
                                  />
                                </Form.Item>
                                <Form.Item
                                  name={[field.name, "Count"]}
                                  rules={[{ required: true }]}
                                  className={cls(
                                    "input-wrapper",
                                    styles.form_item_order_price
                                  )}
                                >
                                  <InputNumber
                                    placeholder={t.count}
                                    min={1}
                                    className={styles.input_num}
                                  />
                                </Form.Item>
                                <Button
                                  type="link"
                                  className={styles.remove_prod_btn}
                                  onClick={() => remove(field.name)}
                                >
                                  <BiMinus />
                                </Button>
                                <Button
                                  className={styles.add_prod_btn}
                                  type="primary"
                                  ghost
                                  onClick={() => add()}
                                >
                                  {/* <OwnImage
                                  src="/images/icons/Icon awesome-plus.svg"
                                  layout="fill"
                                  width="3.2rem"
                                  alt="plus icon"
                                /> */}
                                  + {t.addProduct}
                                </Button>
                              </div>
                            ));
                          }}
                        </Form.List>
                      </div>
                    </div>
                  </div>
                )}

                {/* DELIVERY NOTES */}
                <div className={styles.form_item_wrapper}>
                  <div className="delivery_time_holder">
                    <h2 className={cls("heading-primary left small", heading_primary)}>
                      <span>{t.delivery}</span>
                      <span className="color">{t.notes}</span>
                    </h2>
                    <Form.Item
                      name="DeliveryNote"
                      className={cls("input-holder")}
                    >
                      <Input.TextArea
                        placeholder={`${t.Pleaseinput} ${t.deliveryNotes}`}
                        rows={6}
                        style={{ padding: "2rem" }}
                      />
                    </Form.Item>
                  </div>
                </div>
                {/*  */}
                <div className={styles.form_item_wrapper}>
                  <Form.Item>
                    <Button
                      type="primary"
                      className={css(btnPrimary, "btn-primary fw")}
                      htmlType="submit"
                    >
                      {t.startDeliver}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderDelivery;
